//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbProductTileColorsSelector from '@/elements/product-tile/product-tile-bottom-carousel/product-tile-colors-selector/rb-product-tile-colors-selector.vue'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
export default {
  name: 'product-tile-bottom-carousel',
  components: {
    RbProductTileColorsSelector,
  },
  inject: ['isLoading', 'isPlpExclusive', 'getIsTileFocused'],
  props: {
    hover: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: Array,
      default: () => [],
    },
    selectedIndex: {
      type: Number,
      default: 0,
    },
    category: {
      type: String,
      default: '',
    },
    firstHover: {
      type: Boolean,
      default: false,
    },
    isAddToCart: {
      type: Boolean,
      default: false,
    },
    selectedVariant: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      swiperConfig: {
        slidesPerView: 'auto',
      },
    }
  },
  computed: {
    colorsSelectorIsVisible() {
      if (this.colors.length <= 1 || this.isLoading) {
        return false
      }

      if (this.firstHover) {
        return true
      }

      if (this.isPlpExclusive) {
        return true
      }

      if (this.isMobile) {
        return false
      }

      return this.hover || this.isTileFocused
    },
    isMobile() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
    isTileFocused() {
      return this.getIsTileFocused()
    },
    dataDescriptionCustomize() {
      return `${this.selectedVariant?.name}_${this.selectedVariant?.partNumber}`
    },
  },
  methods: {
    selectIndex(i) {
      this.$emit('update:select-index', i)
    },
    addToBag() {
      this.$emit('action:add-to-bag', this.selectedVariant)
    },
  },
}
